module.exports = __webpack_public_path__ + "static/media/7a.beecd45d.png";